import { ActionTree } from "vuex";
import { AnnotationStateV2, AnnotationObject } from "./state";

/**
 * Map objects from BE (array of JSON strings) to AnnotationObject[]
 */
export const mapObjectsFromBE = (objectStrings: string[] | undefined): AnnotationObject[] => {
  if (!objectStrings || !Array.isArray(objectStrings)) return [];

  return objectStrings
    .map((jsonStr) => {
      try {
        const fabricObj = JSON.parse(jsonStr);
        return {
          objectId: fabricObj.objectId || "",
          type: fabricObj.type || "unknown",
          userId: fabricObj.id || "",
          metadata: jsonStr, // Store the original JSON string
          timestamp: fabricObj.createdOrder,
        };
      } catch (error) {
        console.error("Failed to parse object from BE:", error);
        return null;
      }
    })
    .filter(Boolean) as AnnotationObject[];
};

const actions: ActionTree<AnnotationStateV2, any> = {
  //
};

export default actions;
